import { Component, Input, ViewChild } from '@angular/core';
import { KeyValueDefinitions } from '../../../../../core/helpers/KeyValueDefinitions';
import { KeyValueModel } from '../../../../../core/models/misc/key-value/key-value.model';
import { AddLabelsComponent } from '../../../../../shared/components/add-labels/add-labels.component';

@Component({
    selector: 'app-add-labels-and-annotations',
    templateUrl: './add-labels-and-annotations.component.html',
    styleUrls: ['./add-labels-and-annotations.component.scss'],
    standalone: false
})
export class AddLabelsAndAnnotationsComponent {
    KeyValueDefinitions = KeyValueDefinitions;
	@ViewChild('addLabelsComponent')
	    addLabelsComponent: AddLabelsComponent;
	@ViewChild('addAnnotationsComponent')
	    addAnnotationsComponent: AddLabelsComponent;

	@Input() labels: KeyValueModel[] = [];
	@Input() annotations: KeyValueModel[] = [];
	@Input() fixed: boolean;
	@Input() expanded = true;
	@Input() labelsExpanded = true;
	@Input() annotationsExpanded = true;
	@Input() isLabelsEnabled = true;
	@Input() isAnnotationsEnabled = true;

	validateLabels() {
	    if (!this.addLabelsComponent) {
	        return true;
	    }
	    return this.addLabelsComponent.validateLabels();
	}

	validateAnnotations() {
	    if (!this.addAnnotationsComponent) {
	        return true;
	    }
	    return this.addAnnotationsComponent.validateLabels();
	}
}
